module.exports = __webpack_public_path__ + "img/hr-carousel-background-large@2x.d4b9591d.png";